import instance from 'api';
import { endpoints } from 'endpoints.config';
import { SetPasswordPost } from './models';

export type ApiReturn<T = any> = {
  response: T | null;
  errors: Error[] | null;
};

export const PostSetPassword = async (
  payload: SetPasswordPost
): Promise<ApiReturn> => {
  try {
    const res = await instance.post(endpoints.auth.createPassword, payload);
    if (res.data.status === '1') {
      return {
        response: res.data.details,
        errors: null,
      };
    } else {
      return {
        response: res.data.details,
        errors: res.data.errors,
      };
    }
  } catch (err: any) {
    return {
      response: null,
      errors: err,
    };
  }
};
